import React from 'react';
import { footerStyle } from '../../../helpers/getEmailTemplateStyles';

const Footer = (props) => {

  return (
    <div style={footerStyle}>Sent with &#10084; from {props.siteName}</div>
  );
};

export default Footer;
